import React, { useState } from "react"
import styles from "./Shared.module.css"

interface TooltipProps {
  text: string
}

const Tooltip: React.FC<TooltipProps> = ({ text }) => {
  const [visible, setVisible] = useState(false)

  return (
    <div
      className={styles.tooltipWrapper}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <span className={styles.infoIcon}>i</span>
      {visible && <div className={styles.tooltipBox}>{text}</div>}
    </div>
  )
}

export default Tooltip
